module.exports = __webpack_public_path__ + "img/btn.2545d642.gif";